import { gql } from "@apollo/client";

export const addUserQuestionnaires = gql`
  mutation addUserQuestionnaire($record: CreateOneUserQuestionnairesInput!) {
    userQuestionnaire_CreateOne(record: $record) {
      record {
        _id
      }
    }
  }
`;

export const editUserQuestionnaires = gql`
  mutation editUserQuestionnaire($_id: MongoID!, $record: UpdateByIdUserQuestionnairesInput!) {
    userQuestionnaire_UpdateById(_id :$_id, record: $record) {
      record {
        _id
      }
    }
  }
`;

export const editUserQuestionnairesQuestions = gql`
  mutation editUserQuestionnaire($id: String!, $questions: [QuestionsInput]!) {
    userQuestionnaire_UpdateQuestion(id :$id, questions: $questions) {
      _id
    }
  }
`;

export const removeUserQuestionnaires = gql`
  mutation removeUserQuestionnaire($_id: MongoID!) {
    userQuestionnaire_RemoveById(_id :$_id) {
      record {
        _id
      }
    }
  }
`;